var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveTutors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chalkboard-user",
    d: "M14,23a1,1,0,0,1-1,1H1a1,1,0,0,1-1-1,7,7,0,0,1,14,0ZM7,6a4,4,0,1,0,4,4A4,4,0,0,0,7,6ZM24,5v8a5,5,0,0,1-5,5H14.474a9.064,9.064,0,0,0-3.839-3.227A6,6,0,0,0,4.021,4.791,5,5,0,0,1,9,0H19A5,5,0,0,1,24,5ZM20,15a1,1,0,0,0-1-1H15.5a1,1,0,0,0,0,2H19A1,1,0,0,0,20,15Z",
    fill: "#136ad0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTutors);
export default __webpack_public_path__ + "static/media/active-tutors.74eb9434f74134090bbed52f8b7515db.svg";
export { ForwardRef as ReactComponent };